export function getWebCrypto() {
    return globalThis.crypto;
}
